module.exports = __webpack_public_path__ + "media/images/athletes/3106-80e4ee9b1d8b66b5ab287477f5dc9856.png";